import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Container, Header, Footnote, Anchor } from 'Components/core';
import { colors } from 'Constants';

import InfoBox from 'Components/InfoBox';

// Images
import complexAndChronic from './images/ASA_Section_Titles_04.jpeg';
import contactUs from './images/contact-us.jpg';
import everydayCare from './images/ASA_Section_Titles_03.jpeg';
import familyPlanning from './images/family-planning.jpg';
import ASA_Section_EmergencyTravelAssisstance from './images/ASA_Section_EmergencyTravelAssisstance.jpeg';
import COM_LOGO from './images/com.png';

import AppStoreIOS from 'Images/store-icon-ios.png';
import AppStoreAndroid from 'Images/store-icon-android.png';

// State
import { Subscribe } from 'laco-react';
import { ApiStore } from 'Store';
import CODES from 'Root/libs/analytics/CodeDef';
import Api from 'Root/libs/analytics/Api';
import { replaceAnchor } from 'Root/libs/anchor';
import { SubHeader, TitleHeader } from 'Components/core/Header';



const getMedicalExpensesText=(state)=>{


  if(state?.benefitBrand=='GeoBlue' && ((state?.brandID=='Empire BCBS') || (state?.brandID=='Empire BC')  ))
  {
    return "Coverage outside the U.S. excluding your home country Medical care Coverage is based on medical plan benefits. You should refer to your existing health plan for full details of what's included and what is not."
  }

  return "Maximum benefit up to $250,000 each coverage year, no deductibles or copays. Consult coverage certificate for benefit limitations and exclusions.³"
}
 
function hexToRgb(hex, alpha) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `rgba(
      ${parseInt(result[1], 16)},
      ${parseInt(result[2], 16)},
      ${parseInt(result[3], 16)},
      ${alpha || 1})`
    : undefined;
}

const TDdark=styled.td`

background-color:${colors.textAccent} ;
color:${colors.textOnAccent} ;

`;

const TDLight=styled.td`

background-color:${colors.accentLight} ;
color:${colors.textAccent} ;

`;


const ServiceName=styled.div`
font-weight:bold ;
margin-bottom:1px ;
margin-top:40px ;
`;

const Table = styled.table`
margin-top:20px ;
  border-collapse: collapse;
  tr > * {
    padding: 8px;
    ${props => props.center && css(`text-align: center;`)}
  }

  th {
    font-weight: normal;
    text-align: left;
  }

  tr:nth-child(1) {
    th:nth-child(1) {
      background-color: ${props => props.color1};
      color: ${colors.textOnAccent};
    }

    th:nth-child(3n + 2) {
      background-color: ${props => props.color2};
      color: ${colors.textOnAccent};
    }

    th:nth-child(3n + 3) {
      background-color: ${props => props.color3};
      color: ${colors.textOnAccent};
    }
    th:nth-child(3n + 4) {
      background-color: ${props => props.color4};
      color: ${colors.textOnAccent};
    }
  }

  .row:nth-child(even) {
    background-color: #e2f2f2;
  }

  tr {
    > td:nth-child(1) {
      background-color: ${props => hexToRgb(props.color1, 0.2)};
    }

    > td:nth-child(3n + 2) {
      background-color: ${props => hexToRgb(props.color2, 0.2)};
    }

    > td:nth-child(3n + 3) {
      background-color: ${props => hexToRgb(props.color3, 0.2)};
    }

    > td:nth-child(3n + 4) {
      background-color: ${props => hexToRgb(props.color4, 0.2)};
    }
  }
`;

export default () => {

  useEffect(()=>{
    Api.recordAcitity(CODES.Access_Care);
  },[]);

  return  (
    <Subscribe to={[ApiStore]}>
      {state => {
        const convenientCareSection=state?.asaWhereForCare?.convenientCare?.section;
        const convenientCareServices=convenientCareSection?.services;

        const studentHealthServicesSection=state?.asaWhereForCare?.studentHealthServices?.section;
        const studentHealthServicesServices=studentHealthServicesSection?.services;

        const renderFooter=(aType)=>
        {
          if(typeof(aType)==='string')
          {
            return <Footnote dangerouslySetInnerHTML={{__html:aType}}></Footnote>;
          }
          return aType.map(text=><Footnote dangerouslySetInnerHTML={{__html:text}}></Footnote>);
        };

        const getMiddleSection=(state)=>{

          if(!state?.asaWhereForCare?.benefitsThatGoWith)
          {
            return null;
          }

          return          (<InfoBox image={ASA_Section_EmergencyTravelAssisstance} header={state?.asaWhereForCare?.benefitsThatGoWith?.section?.name}>
                          
            <p  dangerouslySetInnerHTML={{__html:state?.asaWhereForCare?.benefitsThatGoWith?.section?.summary}}></p>
            <p>
              {state?.benefitBrand=='GeoBlue' && <div style={{display:'flex',alignItems:'center'}}>
                <img style={{width:50,height:'auto'}} src={COM_LOGO} />
                <div>
Visit <Anchor to={state?.benefitBrandURL} code={CODES.EXT_CLICK}>{state?.benefitBrandURL} </Anchor> to learn more
                </div>

              </div>}
              <div>

              </div>
              <Table style={{width:'100%'}}>

                <tr>
                  <TDdark colSpan={2}>
                    <div>
                      <div dangerouslySetInnerHTML={{__html:state?.benefitBrandTitle}} ></div>
                     
                    </div>
                
                  </TDdark>
                </tr>
                <tr>
                  <TDLight colSpan={2}>  <div>
International telemedicine services²
                  </div></TDLight>
                </tr>
                <tr>
                  <td>
                Global TeleMDIM
                  </td>
                  <td>
                Confidential access to international doctors by phone or video call.
                  </td>
                </tr>
                <tr>
                  <TDLight colSpan={2}>
                Coverage outside of the U.S., excluding student's home country.
                  </TDLight>
                </tr>
                <tr>
                  <td>Medical expenses</td>
                  <td>{getMedicalExpensesText(state)}</td>
                </tr>
                <tr>
                  <TDLight colSpan={2}>
                Coverage worldwide, except within 100 miles of primary residence for U.S. students. 
                    <br/>
                Coverage worldwide, excluding home country for international students.
                  </TDLight>
                </tr>
                <tr>
                  <td>
                Emergency medical evacuation
                  </td>
                  <td>
                Unlimited
                  </td>
                </tr>
                <tr>
                  <td>Repatriation of remains</td>
                  <td>Unlimited</td>
                </tr>

                <tr>
                  <td>Emergency family travel arrangements</td>
                  <td>Maximum benefit up to $5,000 each coverage year</td>
                </tr>

                <tr>
                  <td>Political emergency and natural disaster evacuation (Available only when traveling outside the United States)<sup>4</sup></td>
                  <td>Covered 100% up to $100,000 each person. Subject to a combined $5,000,000 limit for each covered event for all people covered under the plan.</td>
                </tr>

                <tr>
                  <td>Accidental death and dismemberment</td>
                  <td>Maximum benefit up to $10,000 each coverage year</td>
                </tr>
         
              </Table>
            </p>
            {state?.asaWhereForCare?.benefitsThatGoWith?.section?.footNotes?.footNote && <div>{renderFooter(state?.asaWhereForCare?.benefitsThatGoWith?.section?.footNotes?.footNote)}</div> }
          </InfoBox>);
      
        };

        return (
          <Container
            seperation="32px"
            column
            maxWidth
            style={{ margin: 'auto', padding: '32px' }}
          >
            <TitleHeader>Where 
          <SubHeader>to get care</SubHeader>

            </TitleHeader>
           
            {convenientCareSection && <InfoBox image={everydayCare} header={convenientCareSection?.name}>

              <div dangerouslySetInnerHTML={{__html:replaceAnchor(convenientCareSection?.summary)}}></div>
              <div>{convenientCareServices?.service?.map(service=><div>
                <ServiceName >{service.name}</ServiceName>
                <div dangerouslySetInnerHTML={{__html:replaceAnchor(service.content)}}></div>
              </div>)}</div>
               
              {convenientCareSection.footNotes?.footNote && <div>{renderFooter(convenientCareSection.footNotes?.footNote)}</div> }
            </InfoBox>}
            {getMiddleSection(state)}

            {studentHealthServicesSection && <InfoBox image={complexAndChronic} header={studentHealthServicesSection?.name}>
           
              <div dangerouslySetInnerHTML={{__html:replaceAnchor(studentHealthServicesSection?.summary)}}></div>
              <div>{studentHealthServicesServices?.service?.map(service=><div>
                <ServiceName>{service.name}</ServiceName>
                <div dangerouslySetInnerHTML={{__html:replaceAnchor(service.content)}}></div>
              </div>)}</div>
  
              {studentHealthServicesSection.footNotes?.footNote && <div>{renderFooter(studentHealthServicesSection.footNotes?.footNote)}</div> }
            </InfoBox>}

          </Container>
        );
      }}
    </Subscribe>
  );
};